const getCorrectName = (name) => {
    return name.split('')[name.length - 1] === ' ' ? name.slice(0, -1) : name;
};
export function convert(objects) {
    return objects.map((object) => [getCorrectName(object.name), object.id.toString()]);
}
